import React, { useEffect, useState } from 'react';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import Help_Seo from '../../SEO/Help_Seo';
import FsLightbox from 'fslightbox-react';

function Help() {
    const [isLoading, setIsLoading] = useState(true);
    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        source: '',
    });

    useEffect(() => {
        // Simulate an asynchronous operation (e.g., fetching data)
        setTimeout(() => {
            setIsLoading(false);
        }, 500); // Simulating a 1-second delay
    }, []);

    const openVideoPopup = (videoUrl) => {
        setLightboxController({
            toggler: !lightboxController.toggler,
            source: videoUrl,
        });
    };

    return (
        <div>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Help_Seo />
                    <div className="page-wrapper">
                        <Header />
                        {/* Internal CSS */}
                        <style>
                            {`
                            .header-wrap.style1 .header-top .header-top-left .contact-item a, 
                            .header-wrap.style1 .header-top .header-top-right .social-profile li a i {
                                color: #fff;
                            }
                            .header-wrap.style1 .header-top .header-top-left .contact-item a:hover, 
                            .header-wrap.style1 .header-top .header-top-right .social-profile li a:hover i {
                                color: #FF414B;
                            }
                            .circle {
                                transform: translate(130%, -50%);
                                transition: 0.5s;
                            }
                            @media only screen and (max-width: 767px) {
                                .circle {
                                    transform: translate(195%, -50%);
                                }
                                .video-play {
                                    width: 55px;
                                    height: 55px;
                                }
                            }
                        `}
                        </style>
                        {/* Content Wrapper Start */}
                        <div className="content-wrapper">
                            {/* Breadcrumb start */}
                            <div className="breadcrumb-wrap bg-f">
                                <div className="overlay bg-vulcan op-9" />
                                <div className="container">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="breadcrumb-title">
                                                <h2>Help</h2>
                                                <ul className="breadcrumb-menu list-style">
                                                    <li><NavLink to="/">Home </NavLink></li>
                                                    <li>Help</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Breadcrumb end */}
                            {/* Help section start */}
                            <section className="why-choose-wrap style1 ptb-100">
                                <div className="container">
                                    <div className="row gx-5">
                                        <div className="col-lg-4">
                                            <div className="why-choose-content">
                                                <div className="content-title style1 mb-40">
                                                    <span>For Documents</span>
                                                </div>
                                                <div className="wh-item-wrap">
                                                    <div className="wh-item" style={{ alignItems: 'center' }}>
                                                        <div className="wh-icon">
                                                            <img src="assets/img/photo/kyc.png" alt="KYC" />
                                                        </div>
                                                        <div className="wh-text">
                                                            <h5><NavLink to="/onboarding">KYC Upload</NavLink></h5>
                                                        </div>
                                                        <button
                                                            className="video-play circle"
                                                            onClick={() => openVideoPopup("https://www.youtube.com/watch?v=qceO0YPfcVo")}
                                                        >
                                                            <i className="flaticon-play" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="why-choose-content">
                                                <div className="content-title style1 mb-40">
                                                    <span>For Safety</span>
                                                </div>
                                                <div className="wh-item-wrap">
                                                    <div className="wh-item" style={{ alignItems: 'center' }}>
                                                        <div className="wh-icon">
                                                            <img src="assets/img/photo/data-safety.png" alt="Data Safety" />
                                                        </div>
                                                        <div className="wh-text">
                                                            <h5><NavLink to="/data-safety">Data Safety</NavLink></h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="why-choose-content">
                                                <div className="content-title style1 mb-40">
                                                    <span>For FAQ's</span>
                                                </div>
                                                <div className="wh-item-wrap">
                                                    <div className="wh-item" style={{ alignItems: 'center' }}>
                                                        <div className="wh-icon">
                                                            <img src="assets/img/photo/onbordingfaq.png" alt="Onboarding FAQ" />
                                                        </div>
                                                        <div className="wh-text">
                                                            <h5><NavLink to="/onboarding-faq">Onboarding FAQs</NavLink></h5>
                                                        </div>
                                                    </div>
                                                    <div className="wh-item" style={{ alignItems: 'center' }}>
                                                        <div className="wh-icon">
                                                            <img src="assets/img/photo/faq.png" alt="General FAQ" />
                                                        </div>
                                                        <div className="wh-text">
                                                            <h5><NavLink to="/general-faq">General FAQs</NavLink></h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            {/* Help section end */}
                        </div>
                        {/* Content Wrapper End */}
                        {/* Footer Section Here */}
                        <Footer />
                    </div>
                    {/* FsLightbox Component */}
                    <FsLightbox
                        toggler={lightboxController.toggler}
                        sources={[lightboxController.source]}
                    />
                </>
            )}
        </div>
    );
}

export default Help;
